/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
var IGNORE_DEFAULTS = ['updated_at', 'created_at', 'deleted_at'];
var ChangelogContext = React.createContext({});
function ChangelogContextProvider(props) {
    var _a = useState(props.ignore || IGNORE_DEFAULTS), ignore = _a[0], setIgnore = _a[1];
    var _b = useState(props.dictionary), dictionary = _b[0], setDictionary = _b[1];
    return (React.createElement(ChangelogContext.Provider, { value: {
            ignore: ignore,
            dictionary: dictionary,
        } }, props.children));
}
export { ChangelogContextProvider, ChangelogContext };
//# sourceMappingURL=ChangelogContext.js.map